var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.25,
    stroke: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.7681C8.8385 10.9131 8.94357 11.0503 9.06514 11.1768C9.81987 11.9622 10.9702 12.085 11.8487 11.5451C12.0114 11.4451 12.1648 11.3223 12.3047 11.1768L14.3294 9.06963C15.224 8.13866 15.224 6.62923 14.3294 5.69824C13.4348 4.76725 11.9844 4.76726 11.0898 5.69824L10.6439 6.16237",
    stroke: "#295EF1",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35668 13.8375L8.91053 14.3018C8.01596 15.2328 6.56553 15.2328 5.67095 14.3018C4.77635 13.3708 4.77635 11.8614 5.67095 10.9304L7.6957 8.82325C8.59029 7.89225 10.0407 7.89225 10.9353 8.82325C11.0568 8.94969 11.1618 9.08687 11.2504 9.23175",
    stroke: "#295EF1",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedRecords);
export default __webpack_public_path__ + "static/media/icon-linked-records.d376f94b80851fb044ee6e3b1224bf32.svg";
export { ForwardRef as ReactComponent };